import { useFeature } from "~hooks/useFeature";
import { CrowdCoursingLogo, OrbitLogo, SpaceFloridaFullLogo } from "~ui/atoms/Icons";

export type AppLogoVariant = "logoWithTagline" | "navBarLogo";

export interface AppLogoProps {
  logo?: AppLogoVariant;
  style?: { height?: string };
}

/** Brand logo (CrowdCoursing vs Space Florida) driven by feature flags. */
export function AppLogo({ logo = "navBarLogo", style }: AppLogoProps) {
  const sx = {
    height: style?.height ? `${style.height} !important` : "auto",
    width: style?.height ? "auto" : "100%",
  };
  const isSpaceFlorida = useFeature("isSpaceFlorida");
  if (isSpaceFlorida) {
    if (logo === "navBarLogo") {
      // Orbit artwork is very wide; fixed height + width:auto leaves empty space in the nav.
      // Fill the nav width; when a height is passed, treat it as a max (toolbar / mobile overrides).
      const orbitSx = style?.height
        ? {
            display: "block",
            height: "auto",
            maxHeight: `${style.height} !important`,
            maxWidth: "100%",
            width: "auto",
          }
        : { display: "block", height: "auto", width: "100%" };
      return <OrbitLogo sx={orbitSx} />;
    }
    return <SpaceFloridaFullLogo sx={sx} />;
  }
  return <CrowdCoursingLogo sx={sx} />;
}
